import Vue from "vue";
import QuantificationTransformer from "@/transformers/purchase/quantification";
import errorHandler from "@/utils/errorHandler";

export default (affectedId, payload) => {
  const transformed = QuantificationTransformer.send(payload);
  const request = errorHandler(
    Vue.$http.put(`purchase/quantification/${affectedId}/`, transformed)
  );
  return request.then((response) => {
    const data = response.data;
    return data;
  });
};



// WEBPACK FOOTER //
// ./src/services/purchase/updateQuantification.js